/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MonitoringControllerDtoPilotNftListRequest model module.
 * @module model/MonitoringControllerDtoPilotNftListRequest
 * @version 1.0
 */
class MonitoringControllerDtoPilotNftListRequest {
    /**
     * Constructs a new <code>MonitoringControllerDtoPilotNftListRequest</code>.
     * @alias module:model/MonitoringControllerDtoPilotNftListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        MonitoringControllerDtoPilotNftListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>MonitoringControllerDtoPilotNftListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoPilotNftListRequest} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoPilotNftListRequest} The populated <code>MonitoringControllerDtoPilotNftListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoPilotNftListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('account')) {
                obj['account'] = ApiClient.convertToType(data['account'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'String');
            }
            if (data.hasOwnProperty('skillType')) {
                obj['skillType'] = ApiClient.convertToType(data['skillType'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoPilotNftListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoPilotNftListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MonitoringControllerDtoPilotNftListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['grade'] && !(typeof data['grade'] === 'string' || data['grade'] instanceof String)) {
            throw new Error("Expected the field `grade` to be a primitive type in the JSON string but got " + data['grade']);
        }
        // ensure the json data is a string
        if (data['skillType'] && !(typeof data['skillType'] === 'string' || data['skillType'] instanceof String)) {
            throw new Error("Expected the field `skillType` to be a primitive type in the JSON string but got " + data['skillType']);
        }

        return true;
    }


}

MonitoringControllerDtoPilotNftListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
MonitoringControllerDtoPilotNftListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
MonitoringControllerDtoPilotNftListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
MonitoringControllerDtoPilotNftListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} account
 */
MonitoringControllerDtoPilotNftListRequest.prototype['account'] = undefined;

/**
 * @member {Number} nftUid
 */
MonitoringControllerDtoPilotNftListRequest.prototype['nftUid'] = undefined;

/**
 * @member {String} grade
 */
MonitoringControllerDtoPilotNftListRequest.prototype['grade'] = undefined;

/**
 * @member {String} skillType
 */
MonitoringControllerDtoPilotNftListRequest.prototype['skillType'] = undefined;






export default MonitoringControllerDtoPilotNftListRequest;

